import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';

const styles = theme => ({
  root: {
    paddingBottom: theme.spacing(2),
  },
  label: {},
});

const FilterGroupSection = ({
  children,
  label,
  classes,
  className,
  ...rest
}) => {
  return (
    <div className={classNames(classes.root, className)} {...rest}>
      {label && (
        <Typography
          color="primary"
          variant="h6"
          className={classes.label}
        >
          {label}
        </Typography>)
      }
      {children}
    </div>
  );
};

FilterGroupSection.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
};

FilterGroupSection.defaultProps = {
  className: '',
  label: null,
};

export default withStyles(styles)(FilterGroupSection);
